<template>
  <AppToggleDropdownItem
    :disabled="disabled"
    :active="active"
    :has-submenu="hasSubmenu"
    @click="onClick"
  >
    <slot></slot>
  </AppToggleDropdownItem>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from '~/stores/ReportStore/types';

export default {
  name: 'ReportColumnToggle',
  props: {
    queryProperty: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hasSubmenu: {
      type: Boolean,
      default: false,
    },
    updateSearch: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters(['reportQuery']),
    active: {
      get() {
        if (this.disabled) {
          return true;
        }

        return !!this.reportQuery.filters[this.queryProperty];
      },
      set(newValue) {
        const payload = { [this.queryProperty]: newValue };

        if (this.updateSearch) {
          return this.$store.dispatch('updateSearch', payload);
        }

        return this.$store.commit(types.SET_FILTER, payload);
      },
    },
  },
  methods: {
    onClick() {
      if (!this.disabled) {
        this.active = !this.active;
      }
    },
  },
};
</script>
